// Widget command bus — cross-bundle channel for driving the chat widget from
// other React islands (e.g. the AI Rules & Knowledge → Documents settings page).
//
// The settings island lives in the `application.js` webpack pack; the chat
// widget lives in the `chat-widget.ts` pack. They are SEPARATE bundles, so a
// module-level singleton is NOT shared between them. This bus therefore
// communicates exclusively through `window` (same pattern as pageContextBus):
//
//   - dispatchWidgetCommand(cmd) fires a CustomEvent the widget listens for.
//   - subscribeWidgetCommands(cb) registers the widget's handler.
//
// Command payloads may carry live `File` objects — those are passed by
// reference through the CustomEvent detail (same window/JS realm, no
// serialization), so the widget can upload them directly.
const EVENT_NAME = 'ipa:widget-command';
function busWindow() {
    return typeof window === 'undefined' ? null : window;
}
/** Dispatch a command to the (possibly not-yet-mounted) chat widget. */
export function dispatchWidgetCommand(command) {
    const win = busWindow();
    if (!win)
        return;
    win.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: command }));
}
/**
 * Subscribe to widget commands. Returns an unsubscribe function. Unlike the
 * page-context bus there is no replay of a "current" value — commands are
 * one-shot actions, so a widget that mounts after a dispatch simply misses it
 * (the widget is always mounted before the user can click Add Document).
 */
export function subscribeWidgetCommands(callback) {
    const win = busWindow();
    if (!win)
        return () => undefined;
    const handler = (event) => {
        const detail = event.detail;
        if (detail)
            callback(detail);
    };
    win.addEventListener(EVENT_NAME, handler);
    return () => {
        win.removeEventListener(EVENT_NAME, handler);
    };
}
// Exported for tests that need the raw event name.
export const __testing = { EVENT_NAME };
